import { cloneDeep, isEqual } from 'lodash';
import { states } from '@/constants/lifecycle';
import findResult, { hasMinimumLength, removeEmpty } from '@/utils/resultsHelper';
import {
  datasourceFeatureStatuses,
  datasourceFeatureCategories,
  datasourceTypes,
  externalDatasourceTypes,
} from './constants';
import { baseDatasourceSetting, newDatasourceSettings } from './state/state';

export const datasourceSupportsFeature = (datasource, category, code) => {
  const status = datasource?.features?.[category]?.features?.[code];
  return status && status !== datasourceFeatureStatuses.UNSUPPORTED;
};

export const datasourceSupportsCategory = (datasource, category) => {
  const status = datasource?.features?.[category]?.status;
  return status && status !== datasourceFeatureStatuses.UNSUPPORTED;
};

export const datasourceCategoryEnabled = (datasource, category) => (
  datasource?.features?.[category]?.status === datasourceFeatureStatuses.ENABLED
);

export const datasourceIngestEnabled = (datasource) => (
  datasourceCategoryEnabled(datasource, datasourceFeatureCategories.INGEST)
);

export const datasourceSupportsCohort = (datasource) => (
  datasourceSupportsCategory(datasource, datasourceFeatureCategories.COHORT)
);

export const datasourceSupportsManagement = (datasource) => (
  datasourceSupportsCategory(datasource, datasourceFeatureCategories.MANAGEMENT)
);

export const datasourceSupportsTesting = (settings, validator) => ((settings.testStatus === states.PENDING
    || settings.saveStatus === states.PENDING
    || !validator) ? false : validator(settings).length === 0);

export const datasetWizardIngestEnabled = ({ category, code }, isNew, features, settings) => {
  if (isNew) {
    const item = findResult(settings, category, code) || newDatasourceSettings({ code });
    return !Object.values(externalDatasourceTypes).includes(item.copy.type);
  }

  return datasourceCategoryEnabled(features, datasourceFeatureCategories.INGEST);
};

export const datasourceTestIcon = ({ connection }) => {
  if (connection === true) {
    return { name: 'check circle outline', alt: 'success.title' };
  }
  if (connection === false) {
    return { name: 'times circle outline', alt: 'error.title' };
  }
  return { name: 'power off', alt: 'not.tested' };
};

const crushSettings = (item) => {
  const keys = removeEmpty(Object.keys(item).map((key) => (!hasMinimumLength(item[key]) ? key : undefined)));
  if (keys.length === 0) { return item; }
  if (keys.length === Object.keys(item).length) { return undefined; }

  const copy = cloneDeep(item);
  keys.forEach((key) => delete copy[key]);
  return copy;
};

const hasDatasourceChanged = (before, after) => (
  !isEqual(crushSettings(baseDatasourceSetting(before)), crushSettings(baseDatasourceSetting(after)))
);

export const supportedDatasourceTypes = (datasources, item) => {
  const externalOnly = item.source_exists ? false
    : Object.values(externalDatasourceTypes).includes(item.type);
  const types = datasources.filter((type) => type.enabled || type.code === item.type);
  return externalOnly ? types.filter((type) => type.code !== datasourceTypes.INTERNAL) : types;
};

export default hasDatasourceChanged;
